<template>
    <div class="user_top">
        <div class="usertopnr">
            <h1 class="lf">考试任务</h1>
            <div class="usertoprf rf">
                <span class="lf"  v-if="userhost"><i class="el-icon-setting"></i>
                <router-link :to="{ name:'index'}" v-if="userhost">
                    后台管理
                </router-link></span>
                <img :src='pic' class="lf">
                <em>{{username}}</em>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:'comtop', 
        data () {
        return {
            userhost:false,
            userid: localStorage.getItem('userid'),
            username: '',
            pic:localStorage.getItem('pic'),
          }
      },
      mounted(){
          let data = {
              service:'Index.Check_Admin',
              user_id:this.userid
          }
           this.$axios.post(this.HOME,this.$qs.stringify(data)).then(res=>{
               this.userhost=res.data.data
               console.log(this.userhost)
           })
          this.username= localStorage.getItem('username')
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/user/userTop.vue